<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">业绩明细</div>
          <div class="money">
            团队:<span class="num">{{ commission }}</span>元 <span class="num">{{ commission_pv }}</span>C<br />
            个人:<span class="num">{{ my_commission }}</span>元 <span class="num">{{ my_commission_pv }}</span>C
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
          <table cellpadding="5" >
            <thead  class="item">
              <tr class="listn">
                <th align="center" >日期</th>
                <th align="center" >团队</th>
                <th align="center" >个人</th>
                <th align="center" >操作</th>
              </tr>
            </thead>
            <tbody  v-for="(val, index) in info" :key="index" class="item">
                <tr   class="listn listn2">
                  <td align="center">{{val._add_month}}</td>
                  <td align="center">{{val.team_total_price}}({{val.team_total_pv}}C)</td>
                  <td align="center">{{val.user_total_price}}({{val.user_total_pv}}C)</td>
                  <td align="center"><router-link  :to="{ path: '/user/income_day/' + val._add_month }" class="bonus_show">明细</router-link></td>
                </tr>
            </tbody>

          </table>
      </div>
    </div>

    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#005e29;
    font-size:0.3rem;
  }
</style>
<script>
import {  getIncomeListMonth } from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "IncomeMonth";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
        allBonus:[],
        commission: 0,
        commission_pv: 0,

        my_commission: 0,
        my_commission_pv: 0,
        allBonusCountCan:2,
      where: {
        page: 1,
        limit: 20,
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },

  mounted: function() {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
        getIncomeListMonth(that.where).then(
        res => {
          that.loading = false;
          that.allBonus = res.data.allBonus;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
          that.commission = res.data.teammoney;
          that.commission_pv = res.data.teampv;
          that.my_commission = res.data.mymoney;
          that.my_commission_pv = res.data.mypv;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
